export default "__VITE_ASSET__f3Z1jWXt__"